import { BaseConfig } from '../ServiceConfig';

export interface TempoConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.TempoServiceConfigData';
  domainWebview: string;
  domainApi: string;
  appId: number;
}

export const TempoConfigurationFields: (keyof TempoConfiguration)[] = [
  'domainWebview',
  'domainApi',
  'appId',
];

export const BlankTempoConfiguration: TempoConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.TempoServiceConfigData',
} as TempoConfiguration;
